import React, { useMemo } from 'react';
import css from './VehicleImages.module.scss';
import AlfaRomeo from 'src/content/images/Makes/AlfaRomeo.png';
import AstonMartin from 'src/content/images/Makes/AstonMartin.png';
import Audi from 'src/content/images/Makes/Audi.png';
import AudiLanding from 'src/content/images/Makes/AudiWhite.png';
import Bentley from 'src/content/images/Makes/Bentley.png';
import BMWLanding from 'src/content/images/Makes/BMWLanding.png';
import BMWMenu from 'src/content/images/Makes/BMWMenu.png';
import BMWMenu2 from 'src/content/images/Makes/BMWMenu2.png';
import BMWColorSensitive from 'src/content/images/Makes/BMWColorSensitive.png';
import Bugatti from 'src/content/images/Makes/Bugatti.png';
import Cadillac from 'src/content/images/Makes/Cadillac.png';
import CadillacSmall from 'src/content/images/Makes/Cadillac-White-sm.png';
import CadillacLanding from 'src/content/images/Makes/Cadillac-White.png';
import Chevrolet from 'src/content/images/Makes/Chevrolet.png';
import Chrysler from 'src/content/images/Makes/Chrysler.png';
import Dodge from 'src/content/images/Makes/Dodge.png';
import Dodge2 from 'src/content/images/Makes/Dodge2.png';
import DodgeLanding from 'src/content/images/Makes/DodgeLanding.png';
import Ferrari from 'src/content/images/Makes/Ferrari.png';
import Fiat from 'src/content/images/Makes/Fiat.png';
import Ford from 'src/content/images/Makes/Ford.png';
import Gmc from 'src/content/images/Makes/GMC.png';
import Honda from 'src/content/images/Makes/Honda.png';
import HondaWhite from 'src/content/images/Makes/HondaWhite.png';
import HondaCA from 'src/content/images/Makes/HondaCA.png';
import Hummer from 'src/content/images/Makes/Hummer.png';
import Hyundai from 'src/content/images/Makes/Hyundai.png';
import Infiniti from 'src/content/images/Makes/Infiniti.png';
import InfinitiWhite from 'src/content/images/Makes/InfinitiWhite.png';
import JaguarLight from 'src/content/images/Makes/Jaguar-Logo-WHT.png';
import JaguarDark from 'src/content/images/Makes/Jaguar-Logo-GRY.png';
import Jeep from 'src/content/images/Makes/Jeep.png';
import JeepLanding from 'src/content/images/Makes/JeepLanding.png';
import Kia from 'src/content/images/Makes/Kia.svg';
import KiaWhite from 'src/content/images/Makes/KiaLanding.svg';
import Lamborghini from 'src/content/images/Makes/Lamborghini.png';
import LandRoverLight from 'src/content/images/Makes/LandRover-Logo-2D-WHT.png';
import LandRoverDark from 'src/content/images/Makes/LandRover-Logo-2D-BLU.png';
import Lexus from 'src/content/images/Makes/Lexus.png';
import LexusMonogram from 'src/content/images/Makes/LexusMonogram.png';
import LexusMonogramWhite from 'src/content/images/Makes/LexusMonogram-White.png';
// import LexusLandingPage from 'src/content/images/Makes/LexusLandingPage.svg';
// import LexusMenu from 'src/content/images/Makes/LexusMenu.svg';
import Lincoln from 'src/content/images/Makes/Lincoln.png';
import LincolnADA from 'src/content/images/Makes/LincolnADA.png';
import Maserati from 'src/content/images/Makes/Maserati.png';
// import Mazda from 'src/content/images/Makes/Mazda.png';
import MazdaTrans from 'src/content/images/Makes/MazdaTrans.png';
import Mercedes from 'src/content/images/Makes/Mercedes-Benz.png';
import Mini from 'src/content/images/Makes/Mini.png';
import Nissan from 'src/content/images/Makes/Nissan-BLK.jpg';
import NissanLanding from 'src/content/images/Makes/Nissan-WHT-Transparent.png';
import NissanMenu from 'src/content/images/Makes/Nissan-BLK-Transparent.png';
import Porsche from 'src/content/images/Makes/Porsche-Logo-BLK.png';
// import PorscheADA from 'src/content/images/Makes/Porsche-Logo-BLK.png';
import Ram from 'src/content/images/Makes/Ram.png';
import RamLanding from 'src/content/images/Makes/RamLanding.png';
import Smart from 'src/content/images/Makes/Smart.png';
import Subaru from 'src/content/images/Makes/Subaru.png';
import SubaruNonLP from 'src/content/images/Makes/SubaruNonLP.png';
import Suzuki from 'src/content/images/Makes/Suzuki.png';
// import Toyota from 'src/content/images/Makes/Toyota.png';
import Toyota from 'src/content/images/Makes/ToyotaLogo.png';
import ToyotaLanding from 'src/content/images/Makes/ToyotaLogoWhite.png';
// import ToyotaSPM from 'src/content/images/Makes/ToyotaSPM.png';
import ToyotaSPM2 from 'src/content/images/Makes/ToyotaSPM2.png';
import ToyotaSPMLanding from 'src/content/images/Makes/ToyotaSPMWhite.png';
import VolksWagenThumb from 'src/content/images/Makes/Volkswagen.png';
import VolkswagenLanding from 'src/content/images/Makes/VW-Logo-White.png';
import VolkswagenMenu from 'src/content/images/Makes/VW-Logo-DarkBlue.png';
import Volvo from 'src/content/images/Makes/Volvo.png';
import Acura from 'src/content/images/Makes/Acura.png';
import AcuraWhite from 'src/content/images/Makes/AcuraWhite.png';
import AcuraCanada from 'src/content/images/Makes/AcuraCanada.png';
import AcuraCanadaWhite from 'src/content/images/Makes/AcuraCanadaWhite.png';
import Buick from 'src/content/images/Makes/Buick.png';
import CDJR from 'src/content/images/Makes/CDJR.png';
import GM from 'src/content/images/Makes/GM.svg';
import classNames from 'classnames';
import { checkSpecTheme } from 'src/helpers/OEMHelper/OEMHelper';
import { ServiceDocsData, SpecData } from 'src/models';
// import { lowerCase } from 'lodash';

interface IProps {
    make: string;
    type?: 'menuLogo' | 'thumb' | 'landingLogo' | undefined;
    background?: string;
    theme?: string;
    specData?: SpecData;
    serviceDocsData?: ServiceDocsData;
    setHasImage?: (hasImage: boolean) => void;
}

const VehicleMakeImages = (props: IProps) => {
    const specsTheme = props.specData?.oemTheme ?? '';
    const serviceSpecsTheme = props.serviceDocsData?.theme ?? '';
    const specTheme = checkSpecTheme(specsTheme || serviceSpecsTheme);

    const makeImage = useMemo(() => {
        // const transLit = lowerCase(props.make);
        let make = props.make;
        if ((make === 'Honda' || make === 'honda') && props.theme ==='honda-CA'){
            make='honda-CA';
        }
        if ((make === 'Acura' || make === 'acura') && props.theme ==='acura-CA'){
            make='acura-CA';
        }
        const transLit = make.toLowerCase();
        switch (transLit) {
            // case 'Acura':
            case 'acura-ca':
                switch (props.type) {
                    case 'landingLogo':
                        return AcuraCanadaWhite;
                    case 'menuLogo':
                        return AcuraCanadaWhite;
                    default:
                        return AcuraCanada;
                }
            case 'acura':
                switch (props.type) {
                    case 'landingLogo':
                        return AcuraWhite;
                    case 'menuLogo':
                        return AcuraWhite;
                    default:
                        return Acura;
                }
            case 'acura color sensitive':
                switch (props.type) {
                    case 'landingLogo':
                        return AcuraWhite;
                    default:
                        return Acura;
                }

            // case 'Alfa Romeo':
            // case 'AlfaRomeo':
            case 'alfa romeo':
            case 'alfaromeo':
                return AlfaRomeo;

            // case 'Aston Martin':
            // case 'AstonMartin':
            case 'aston martin':
            case 'astonmartin':
                return AstonMartin;

            // case 'Audi':
            case 'audi':
                if (props.type === 'landingLogo') {
                    return AudiLanding;
                } else {
                    return Audi;
                }
            case 'bentley':
                return Bentley;

            // case 'BMW':
            case 'bmw':
            case 'bmwi':
                if (props.type === 'menuLogo') {
                    return BMWMenu2;
                }
                if (props.background === 'dark') {
                    return BMWMenu;
                } else if (props.background === 'light') {
                    return BMWColorSensitive;
                } else {
                    return BMWLanding;
                }
            case 'bmw color sensitive':
                return BMWColorSensitive;
            case 'buick':
                return Buick;
            case 'bugatti':
                return Bugatti;

            // case 'Cadillac':
            case 'cadillac':
                if (props.type === 'landingLogo') {
                    return CadillacLanding;
                }
                if (props.background === 'dark') {
                    return CadillacSmall;
                } else {
                    return Cadillac;
                }
            case 'cjdr':
                return CDJR;
            // case 'Chevrolet':
            case 'chevrolet':
                return Chevrolet;

            // case 'Chrysler':
            case 'chrysler':
            case 'chrysler canada':
                return Chrysler;

            // case 'Dodge':
            case 'dodge':
                // return Dodge;
                if (props.type === 'menuLogo') {
                    return Dodge;
                }
                if (props.background === 'dark') {
                    return DodgeLanding;
                }
                if (props.background === 'light') {
                    return Dodge2;
                }

                return DodgeLanding;

            case 'ferrari':
                return Ferrari;

            case 'fiat':
                return Fiat;

            // case 'Ford':
            case 'ford':
            case 'ford truck':
            case 'ford canada':
                return Ford;
            case 'gm':
                return GM;
            // case 'GMC':
            case 'gmc':
                return Gmc;

            // case 'Honda':
            case 'honda-ca':
                return HondaCA;
            case 'honda':
            case 'honda mtc/pp/pe':
                switch (props.type) {
                    case 'landingLogo':
                        return HondaWhite;
                    default:
                        return Honda;
                }
            case 'honda color sensitive': {
                return specTheme === 'honda-CA' ? HondaWhite : Honda;
            }

            case 'hummer':
                return Hummer;

            // case 'Hyundai':
            case 'hyundai':
                return Hyundai;

            // case 'Infiniti':
            // case 'INFINITI':
            case 'infiniti':
                return Infiniti;
            case 'infiniti color sensitive':
                switch (props.type) {
                    case 'landingLogo':
                        return InfinitiWhite;
                    default:
                        return Infiniti;
                }

            // case 'Jaguar':
            case 'jaguar':
            case 'jag':
            // case 'JAG':
                if (props.type === 'landingLogo' || props.background === 'dark') {
                    return JaguarLight;
                } else {
                    return JaguarDark;
                }

            // case 'Jeep':
            case 'jeep':
                // return Jeep;
                if (props.type === 'menuLogo') {
                    return Jeep;
                } else {
                    return JeepLanding;
                }

            // case 'Kia':
            case 'kia':
                if (props.background === 'dark') {
                    return KiaWhite;
                } else {
                    return Kia;
                }

            case 'lamborghini':
                return Lamborghini;

            // case 'Land Rover':
            // case 'LandRover':
            case 'land rover':
            case 'landrover':
                if (props.type === 'landingLogo' || props.background === 'dark') {
                    return LandRoverLight;
                } else {
                    return LandRoverDark;
                }

            // case 'Lexus':
            case 'lexus':
                return Lexus;
                // if (props.type === 'menuLogo') {
                //     return LexusMenu;
                // } else {
                //     return LexusLandingPage;
                // }

            case 'lexusmonogram':
                return LexusMonogram;
            case 'lexus monogram color sensitive':
                if (props.type === 'landingLogo' || props.background === 'dark') {
                    return LexusMonogramWhite;
                } else {
                    return LexusMonogram;
                }

            // case 'Lincoln':
            case 'lincoln':
                switch (props.type) {
                    case 'landingLogo':
                        return LincolnADA;
                    default:
                        return Lincoln;
                }

            case 'maserati':
                return Maserati;

            // case 'Mazda':
            case 'mazda':
            case 'mazda truck':
                return MazdaTrans;

            case 'mercedes':
            case 'mercedes benz':
            case 'mercedes-benz':
            case 'mercedesbenz':
                return Mercedes;

            // case 'Mini':
            // case 'MINI':
            case 'mini':
                return Mini;

            // case 'Nissan':
            case 'nissan':
                switch (props.type) {
                    case 'landingLogo':
                        return NissanLanding;
                    case 'menuLogo':
                        return NissanMenu;
                    default:
                        return Nissan;
                }
            // case 'Porsche':
            case 'porsche':
                return Porsche;
            case 'porsche color sensitive':
                return Porsche;

            // case 'Ram':
            case 'ram':
                if (props.type === 'landingLogo') {
                    return RamLanding;
                } else {
                    return Ram;
                }

            case 'smart':
                return Smart;

            // case 'Subaru':
            case 'subaru':
                if (props.type === 'landingLogo') {
                    return Subaru;
                } else {
                    return SubaruNonLP;
                }

            case 'suzuki':
                return Suzuki;

            // case 'Toyota':
            case 'toyota':
                if (props.type === 'landingLogo') {
                    return ToyotaLanding;
                } else {
                    return Toyota;
                }
                // return Toyota;

            // case 'ToyotaSPM':
            case 'toyotaspm':

                if (props.type === 'landingLogo') {
                    return ToyotaSPMLanding;
                } else {
                    return ToyotaSPM2;
                }

            // case 'Volkswagen':
            case 'volkswagen':
            case 'vw canada':
                if (props.type === 'menuLogo') {
                    return VolkswagenMenu;
                } else if (props.type === 'thumb') {
                    return VolksWagenThumb;
                } else if (props.type === 'landingLogo') {
                    return VolkswagenLanding;
                } else {
                    return VolkswagenMenu;
                }

            case 'volvo':
                return Volvo;

            default:
                return '';
        }
    }, [props.make, props.theme, props.type, props.background, specTheme]);

    if (makeImage && props.setHasImage) {
        props.setHasImage(true);
    }
    // const onImageLoad = useCallback((event: any) => {
    //     setWidth(event.target.offsetWidth);
    //     setHeight(event.target.offsetHeight);
    // }, []);

    const imageClasses = classNames(
        {
            [css.menuLogo]: props.type === 'menuLogo',
            [css.vehicleModelImage]: props.type === 'thumb',
            [css.landingLogo]: props.type === 'landingLogo',
            [css.vehicleImage]: !props.type,
            [css.toyMenuLogo]: props.type === 'menuLogo' && (props.make.toLowerCase() === 'toyota' ||
                props.make.toLowerCase() === 'toyotaspm'),
            [css.porscheLogo]: (props.type === undefined || props.type === 'thumb') &&
                props.make.toLowerCase() === 'porsche',
            [css.audiLogo]: props.type === 'landingLogo' && props.make === 'audi',
            // first part applies the red BG to the menu logo, second to the vehicle card
            [css.logoAreaHondaCA]: props.make === 'honda-CA' || (props.make === 'Honda' && props.theme === 'honda-CA'),
            [css.benzLogo]: props.make === 'mercedesBenz' || props.make === 'Mercedes-Benz',
        },
    );

    return (
        <div id={'imageContainer_' + props.make} className={props.type === 'menuLogo' ?
            (specTheme === 'honda-CA' ? css.menuLogoAreaHCA : css.menuLogoArea) : ''}>
            <picture>
                { makeImage !== '' ?
                    <img src={makeImage} alt={props.make} className={imageClasses} />:
                    ''
                }
            </picture>
        </div>
    );
};

export default VehicleMakeImages;